import ApiClient from './apiClient'
import {
  CommonPart,
  PostIntroPageParams,
} from '../types/common'
import { PostLangStatusParams } from '../types/setting'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCommonPart = async (): Promise<any> => ApiClient.get(
  '/api/v6/renderer/common_part',
  (result: CommonPart) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postIntroPage = async (params: PostIntroPageParams): Promise<any> => ApiClient.post(
  '/api/v1/renderer/intro_status',
  (result: Record<string, unknown>) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postLangStatus = async (params: PostLangStatusParams): Promise<any> => ApiClient.post(
  '/api/v1/renderer/lang_status',
  (result: Record<string, unknown>) => result,
  params,
)
